<template lang="pug">
  rc-sheets.client-sheets.mt-2(
    showAll paginate clickToVisit
    ref="sheetsTable"
    :sheets="sheets"
    :metadata="metadata"
    :loading="loading"
    @recall="getSheets"
  )
</template>

<script>
import RcSheets from '@/components/RcClients/RcSheets.vue';
import apiSheetService from '@/services/api/ambassador/sheetService';

export default {
  components: {
    RcSheets,
  },
  data() {
    return {
      sheets: [],
      metadata: {},
      loading: false,
    };
  },
  mounted() {
    this.getSheets();
  },
  methods: {
    async getSheets(params = { start: 0, size: 100, filters: [], order: [] }) {
      this.loading = true;
      const sheetsResponse = await apiSheetService.search(params);
      this.sheets = sheetsResponse.data;
      this.metadata = sheetsResponse.metadata;
      this.loading = false;
    },
  },
}
</script>